import React from 'react'
import { Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import DeptTreeContainer from '../../containers/deptmng/DeptTreeContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';


const DeptMngPage = () => {
    return (
        <>
        <BreadcrumbsContainer title="인사관리/부서관리/부서 리스트" />
        <Grid container spacing={2} sx={{ my: 1 }}>
            <Grid item xs={4}>
                <DeptTreeContainer />
            </Grid>
            <Grid item xs={8}>
                <Outlet />
            </Grid>
        </Grid>
        </>
    )
}

export default DeptMngPage